
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import moment from 'moment';
import { CSSTransition } from 'react-transition-group';


import { switchPopupCreateAction, changeScreenAction } from './actions';
import { setActivePanelVKAction } from '../vk/actions';
import { createWriteAction, setCreatingWriteAction } from './actions';
import CreateForm from './createForm';
import { unsetScheduleInterval } from '../../helpers';
import { ReactComponent as IconClose } from '../../assets/close-popup.svg';
import './style.scss';

class CreateWrite extends React.Component {
    switchPopup = () => {
        const { dispatch, schedule } = this.props;
        const { creatingData } = schedule;

        dispatch(switchPopupCreateAction());
        dispatch(setCreatingWriteAction('UNSET', creatingData.ticket));
    }

    onSubmit = (values) => {
        const { dispatch, schedule } = this.props;
        const { creatingData } = schedule;
        const { search } = window.location;

        if (!values.policy) {
            alert('Согласитесь с политикой обработки персональных данных');
            return;
        }

        dispatch(switchPopupCreateAction());
        dispatch(createWriteAction(values, creatingData.ticket));
        dispatch(setCreatingWriteAction('UNSET', creatingData.ticket));

        unsetScheduleInterval();
        if (search !== '') { // for vkminiapp
            dispatch(setActivePanelVKAction('successPanel'));
        } else {
            dispatch(changeScreenAction('success'));
        }
    }

    render() {
        const { schedule } = this.props;
        const { visibleCreatePopup, creatingData } = schedule;
        let dateWrite = '';

        if (creatingData) {
            const { ticket } = creatingData;
            dateWrite = `${moment(ticket.date_ticket).format('D MMMM YYYY')} ${moment(ticket.time_start).format('HH:mm')}-${moment(ticket.time_end).format('HH:mm')}`;
        }

        return (
            <CSSTransition
                classNames="schedulePopup"
                in={visibleCreatePopup}
                unmountOnExit
                timeout={{
                    appear: 0,
                    enter: 0,
                    exit: 300,
                }}
            >
                <Popup
                    position="center center"
                    open
                    className="schedule__popup"
                    closeOnEscape={false}
                    closeOnDocumentClick={false}
                >
                    <>
                        <p className="schedule__popup_title">
                            Создание записи на
                            &nbsp;
                            <b>{dateWrite}</b>
                        </p>
                        <button type="button" className="schedule__popup_close" onClick={() => { this.switchPopup(); }}>
                            <IconClose />
                        </button>
                        <CreateForm onSubmit={this.onSubmit} />
                    </>
                </Popup>
            </CSSTransition>
        );
    }
}

CreateWrite.propTypes = {
    dispatch: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    schedule: state.schedule
});


export default connect(mapStateToProps)(CreateWrite);
